var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2WaitlistWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1478_19919)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3937 40.1771C19.0312 40.5396 18.6083 40.7208 18.125 40.7208C17.6417 40.7208 17.2188 40.5396 16.8562 40.1771C16.4937 39.8146 16.3125 39.3917 16.3125 38.9083C16.3125 38.425 16.4937 38.0021 16.8562 37.6396C17.2188 37.2771 17.6417 37.0958 18.125 37.0958C18.6083 37.0958 19.0312 37.2771 19.3937 37.6396C19.7562 38.0021 19.9375 38.425 19.9375 38.9083C19.9375 39.3917 19.7562 39.8146 19.3937 40.1771ZM19.3937 30.2687C19.0312 30.6312 18.6083 30.8125 18.125 30.8125C17.6417 30.8125 17.2188 30.6312 16.8562 30.2687C16.4937 29.9062 16.3125 29.4833 16.3125 29C16.3125 28.5167 16.4937 28.0937 16.8562 27.7312C17.2188 27.3687 17.6417 27.1875 18.125 27.1875C18.6083 27.1875 19.0312 27.3687 19.3937 27.7312C19.7562 28.0937 19.9375 28.5167 19.9375 29C19.9375 29.4833 19.7562 29.9062 19.3937 30.2687ZM19.3937 20.3604C19.0312 20.7229 18.6083 20.9042 18.125 20.9042C17.6417 20.9042 17.2188 20.7229 16.8562 20.3604C16.4937 19.9979 16.3125 19.575 16.3125 19.0917C16.3125 18.6083 16.4937 18.1854 16.8562 17.8229C17.2188 17.4604 17.6417 17.2792 18.125 17.2792C18.6083 17.2792 19.0312 17.4604 19.3937 17.8229C19.7562 18.1854 19.9375 18.6083 19.9375 19.0917C19.9375 19.575 19.7562 19.9979 19.3937 20.3604ZM32.0292 40.7208H27.9125C27.399 40.7208 26.9685 40.5497 26.6211 40.2073C26.2737 39.8649 26.1 39.4355 26.1 38.9189C26.1 38.4024 26.2737 37.9694 26.6211 37.6199C26.9685 37.2705 27.399 37.0958 27.9125 37.0958H32.0292C32.5427 37.0958 32.9732 37.267 33.3206 37.6094C33.668 37.9517 33.8417 38.3812 33.8417 38.8978C33.8417 39.4143 33.668 39.8473 33.3206 40.1967C32.9732 40.5461 32.5427 40.7208 32.0292 40.7208ZM39.0292 30.8125H27.9125C27.399 30.8125 26.9685 30.6413 26.6211 30.299C26.2737 29.9566 26.1 29.5271 26.1 29.0106C26.1 28.4941 26.2737 28.0611 26.6211 27.7116C26.9685 27.3622 27.399 27.1875 27.9125 27.1875H39.0292C39.5427 27.1875 39.9732 27.3587 40.3206 27.701C40.668 28.0434 40.8417 28.4729 40.8417 28.9894C40.8417 29.5059 40.668 29.9389 40.3206 30.2884C39.9732 30.6378 39.5427 30.8125 39.0292 30.8125ZM39.0292 20.9042H27.9125C27.399 20.9042 26.9685 20.733 26.6211 20.3906C26.2737 20.0483 26.1 19.6188 26.1 19.1022C26.1 18.5857 26.2737 18.1527 26.6211 17.8033C26.9685 17.4539 27.399 17.2792 27.9125 17.2792H39.0292C39.5427 17.2792 39.9732 17.4503 40.3206 17.7927C40.668 18.1351 40.8417 18.5645 40.8417 19.0811C40.8417 19.5976 40.668 20.0306 40.3206 20.3801C39.9732 20.7295 39.5427 20.9042 39.0292 20.9042ZM8.3375 49.6625C9.0625 50.3875 9.90833 50.75 10.875 50.75H38.6854C38.5552 50.636 38.4286 50.5174 38.3056 50.3944C37.592 49.6808 37.0299 48.8467 36.6194 47.8954C36.206 46.9373 36 45.9209 36 44.85C36 43.7791 36.206 42.7627 36.6194 41.8046C37.0299 40.8533 37.592 40.0192 38.3056 39.3056C39.0192 38.592 39.8533 38.0299 40.8046 37.6194C41.7627 37.206 42.7791 37 43.85 37C44.9209 37 45.9373 37.206 46.8954 37.6194C47.8467 38.0299 48.6808 38.592 49.3944 39.3056C49.9324 39.8436 50.3843 40.4501 50.75 41.1237V10.875C50.75 9.90833 50.3875 9.0625 49.6625 8.3375C48.9375 7.6125 48.0917 7.25 47.125 7.25H10.875C9.90833 7.25 9.0625 7.6125 8.3375 8.3375C7.6125 9.0625 7.25 9.90833 7.25 10.875V47.125C7.25 48.0917 7.6125 48.9375 8.3375 49.6625ZM44.4856 50.75C45.8446 50.617 47.0233 50.0482 48.0357 49.0357C49.2029 47.8686 49.7805 46.4805 49.7805 44.85C49.7805 43.2195 49.2029 41.8314 48.0357 40.6643C46.8686 39.4972 45.4805 38.9195 43.85 38.9195C42.2195 38.9195 40.8314 39.4972 39.6643 40.6643C38.4972 41.8314 37.9195 43.2195 37.9195 44.85C37.9195 46.4805 38.4972 47.8686 39.6643 49.0357C40.6767 50.0482 41.8554 50.617 43.2144 50.75H44.4856ZM42.9461 40.4824H44.8656V44.4611L47.9918 47.607L46.5818 49.017L42.9461 45.235V40.4824Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1478_19919",
    x: -4,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1478_19919"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1478_19919",
    result: "effect2_dropShadow_1478_19919"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1478_19919",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2WaitlistWhite);
export default __webpack_public_path__ + "static/media/v2-waitlist-white.bc27df0c4f4cf32e6638967e286f5a3f.svg";
export { ForwardRef as ReactComponent };